// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "brand_media_embedding".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "brand_media_embedding" table (1:1 with a DB row, on the wire). */
export const brandMediaEmbeddingAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaAdsPageId: z.string().nullable(),
    platform: z.string(),
    mediaType: z.string(),
    postId: z.string(),
    caption: z.string(),
    mediaUrl: z.string(),
    thumbnailUrl: z.string().nullable(),
    permalink: z.string(),
    objectKey: z.string().nullable(),
    dhash: z.string().nullable(),
    description: z.string(),
    format: z.string(),
    inspirationVerdict: z.unknown().nullable(),
    gatedAt: z.string().datetime().nullable(),
    postedAt: z.string().datetime().nullable(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=brandMediaEmbedding.js.map